export default __webpack_public_path__ + "static/media/central_credit_logo.b65dd506.jpg";